import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-conductores',
  templateUrl: './administracion-conductores.component.html',
  styleUrls: ['./administracion-conductores.component.css']
})
export class AdministracionConductoresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
